import React, { FC } from 'react'
import {
  BreakdownLedgerContainer,
  buildBreakdownLedgerRows,
} from '../../BreakdownLedger'
import { useTranslation } from 'react-i18next'
import getLocaleCurrencyForAmount from '../../../../../utils/getLocaleCurrencyForAmount'
import { Breakdown } from '../../Breakdown'
import Header from '../../../../Elements/Header'

export interface LCDLicensingBreakdownPreviewProps {
  totalPaid: string
  totalOwed: string
  balance: string
  licensingDue: string
  currencyCode: string
  lcdName: string
}

const LCDLicensingBreakdownPreview: FC<LCDLicensingBreakdownPreviewProps> = ({
  totalPaid,
  totalOwed,
  balance,
  licensingDue,
  currencyCode,
  lcdName,
}) => {
  const { t } = useTranslation()

  const totalOwedRow = buildBreakdownLedgerRows(
    {
      content: t('BreakdownLedger.Row.TotalOwed', 'Total Owed'),
    },
    {
      content: getLocaleCurrencyForAmount(totalOwed, currencyCode),
      cssTextProps: {
        width: '50%',
      },
    },
    {
      content: ' ',
    },
    {
      content: ' ',
    }
  )

  const totalPaidRow = buildBreakdownLedgerRows(
    {
      content: t('BreakdownLedger.Row.TotalPaid', 'Total Paid'),
    },
    {
      content: getLocaleCurrencyForAmount(totalPaid, currencyCode),
      cssTextProps: {
        width: '50%',
      },
    },
    {
      content: ' ',
    },
    {
      content: ' ',
    }
  )

  const balanceRow = buildBreakdownLedgerRows(
    {
      content: t('BreakdownLedger.Row.Balance', 'Balance'),
    },
    {
      content: getLocaleCurrencyForAmount(balance, currencyCode),
      cssTextProps: {
        width: '50%',
      },
    },
    {
      content: ' ',
    },
    {
      content: ' ',
    }
  )

  const licensingDueRow = buildBreakdownLedgerRows(
    {
      content: t('BreakdownLedger.Row.LicensingDue', 'Licensing Due'),
    },
    {
      content: getLocaleCurrencyForAmount(licensingDue, currencyCode),
      cssTextProps: {
        width: '50%',
      },
    },
    {
      content: ' ',
    },
    {
      content: ' ',
    }
  )

  return (
    <>
      <Header
        id="LCDLicensingBreakdownPreview"
        headerName={t(
          'LCDLicensingBreakdownPreview.Header.LcdName',
          'Licensed Community Director - {{lcdName}}',
          { lcdName }
        )}
        variant="Card"
        component="h6"
        css={{
          padding: 0,
        }}
      />
      <BreakdownLedgerContainer
        aria-labelledby="LcdLicensingBreakdownPreview"
        headers={[]}
      >
        {[totalOwedRow, totalPaidRow, balanceRow, licensingDueRow].map(
          (row, index) => (
            <Breakdown
              key={`row-${index}`}
              breakdownRows={[row]}
              variant="Normal"
              cellStyles={{
                paddingRight: 0,
                width: {
                  xs: '40%',
                  md: '10%',
                },
              }}
            />
          )
        )}
      </BreakdownLedgerContainer>
    </>
  )
}

export default LCDLicensingBreakdownPreview
